import axios from "@/lib/request";

// ===== 渠道管理相关接口 =====

// 获取渠道列表（通用列表接口）
export const getChannelGeneralList = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/channel/general/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取渠道列表（基础列表接口）
export const getChannelList = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/channel/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取渠道详情
export const getChannelInfo = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/biz/channel/info",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 新增渠道
export const addChannel = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/biz/channel/add",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 更新渠道信息
export const updateChannel = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/biz/channel/update",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 启用/禁用渠道
export const toggleChannelStatus = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/biz/channel/disabled",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 定制工号
export const customizeChannelAlias = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/channel/alias/customize",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取App列表（用于搜索下拉框）
export const getAppList = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/app/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// ===== API对接账号管理相关接口 =====

// API账户相关接口
export const getApiAccountList = (params) => {
  return axios.request({
    url: '/v1/admin/cmn/client/list',
    method: 'get',
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  })
}

// 获取API对接账号详情
export const getApiAccountInfo = (id) => {
  return axios.request({
    url: "/v1/admin/cmn/client/info",
    method: "get",
    params: { id },
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 新增API对接账号
export const addApiAccount = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/client/save",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 更新API对接账号
export const updateApiAccount = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/client/save",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 删除API对接账号
export const deleteApiAccount = (id) => {
  return axios.request({
    url: "/v1/admin/cmn/client/delete",
    method: "post",
    data: JSON.stringify({ id }),
    headers: {
      'Content-Type': 'application/json',
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 重置API密钥
export const resetApiSecret = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/client/reset/secret",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'AppKey': 'BpLnfgDs'
    }
  });
};

// ===== 渠道投保区域相关接口 =====

// 获取渠道投保区域列表
export const getChannelRegionList = (params) => {
  return axios.request({
    url: "/v1/admin/hynb/cdb/channelcity/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 更新渠道区域
export const updateChannelRegion = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/channel/region/update",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取省份列表
export const getProvinceList = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/province/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取城市列表
export const getCityList = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/city/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};